'use client';
import { useGetCustomerAdvisor } from '@/modules/Customer/http/client/useGetCustomerAdvisor';
import { useGetCustomerStatus } from '@/modules/Customer/http/client/useGetCustomerStatus';
import {
  getWhatsappAdvisorUrl,
  whatsappMessageHandsUpConfig,
} from '@/utils/messenger';

export const useCheckWhatsappHandsUp = () => {
  const { data: advisor } = useGetCustomerAdvisor();
  const { data: { isEqiDigital } = {} } = useGetCustomerStatus();

  const checkToCallWhatsapp = (
    flagScreen: keyof typeof whatsappMessageHandsUpConfig,
    customMessage?: string,
    customPhone?: string
  ) => {
    if (!isEqiDigital) {
      const urlWhatsapp = getWhatsappAdvisorUrl(
        customPhone ?? advisor?.advisorMobilePhone ?? '',
        flagScreen,
        customMessage
      );

      window.open(urlWhatsapp, '_blank');
    }
  };

  return { checkToCallWhatsapp };
};
